import 'assets/scss/components/tabHeader.scss';

/**
 * @param menus string[] ex)['전체', '개방수역', '제한수역']
 * @param defaultTab string 현재 선택 탭
 * @param setSelectedTab () => void 탭 선택 핸들러
 */
const TabHeader = ({marginTop, menus, defaultTab, setSelectedTab, style}) => {
    return(
        <div className='tab-menu-wrap' style={{marginTop: marginTop || 0, ...style}}>
            {menus && menus.map((menu, idx) =>
                <div
                    key={`tab-menu-${idx}`}
                    className={`tab ${defaultTab === menus[idx] ? 'active' : ''} `}
                    onClick={()=>{
                        setSelectedTab && setSelectedTab(menus[idx])
                    }}
                >{menu}</div>)}
        </div>
    )
};

export default TabHeader;